import React from 'react';

import { componentWithFG } from '@atlaskit/platform-feature-flags-react';
import { Stack } from '@atlaskit/primitives/compiled';

import { HierarchyUserCard } from './HierarchyUserCard';
import { ReportsList, VerticalChartLine } from './styles';
import { type HierarchyData } from './types';

interface HierarchyChartProps {
	data: HierarchyData;
	testId?: string;
}

const NoopComponent = () => null;

/**
 * Displays a simple hierarchy chart (manager → user → reports) for a given user.
 *
 * @internal Not ready for consumption. Do not use in production.
 */
export const HierarchyChart: React.FC<HierarchyChartProps & React.RefAttributes<unknown>> =
	componentWithFG('pt_hierarchy_chart_enabled', NoopComponent, HierarchyChartComponent);

function HierarchyChartComponent({ data, testId }: HierarchyChartProps) {
	const { manager, user, reports = [] } = data;
	const hasReports = reports.length > 0;

	return (
		<Stack alignInline="center" testId={testId}>
			{manager && (
				<>
					<HierarchyUserCard user={manager} testId="hierarchy-manager-card" />
					<VerticalChartLine />
				</>
			)}

			<HierarchyUserCard user={user} selected testId="hierarchy-selected-card" />

			{hasReports && (
				<>
					<VerticalChartLine />
					<ReportsList testId="hierarchy-reports-list">
						{reports.map((report) => (
							<HierarchyUserCard
								key={report.accountId}
								user={report}
								testId={`hierarchy-report-card-${report.accountId}`}
							/>
						))}
					</ReportsList>
				</>
			)}
		</Stack>
	);
}
